import { render, staticRenderFns } from "./ScenicHotelBasicInfo.vue?vue&type=template&id=ef080f6c&scoped=true"
import script from "./ScenicHotelBasicInfo.vue?vue&type=script&lang=js"
export * from "./ScenicHotelBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./ScenicHotelBasicInfo.vue?vue&type=style&index=0&id=ef080f6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef080f6c",
  null
  
)

export default component.exports